import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              The role of GIS, LCA and spatial LCA in agro-residue bioenergy
              planning is discussed in this paper. GIS is important for
              distributed resource assessment while LCA is used to evaluate
              environmental consequences of bioenergy generation. Residue
              bioenergy provides distinct environmental benefits over
              conventional energy systems. For assessment of certain spatial
              environmental impacts of bioen- ergy, the use of spatial LCA is
              necessary, however, there are some uncertainties in LCA
              methodologies that can limit its applicability in sound decision
              making. It is recommended that every bioenergy project should
              include Life Cycle Assessment (LCA) as a fundamen- tal project
              development component.
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
